import type { Stats } from "@/types/repo";
import { Code, GitFork, Star, Users } from "@phosphor-icons/react";

interface Props {
  stats: Stats | null;
}

function formatNum(n: number): string {
  if (n >= 1_000_000) return (n / 1_000_000).toFixed(1) + "M";
  if (n >= 1000) return (n / 1000).toFixed(1) + "k";
  return String(n);
}

const ITEMS = [
  { key: "total_repos", label: "Repositories", Icon: Code },
  { key: "total_stars", label: "Stars", Icon: Star },
  { key: "total_forks", label: "Forks", Icon: GitFork },
  { key: "total_contributors", label: "Contributors", Icon: Users },
  { key: "total_loc", label: "Lines of Code", Icon: Code },
] as const;

export function StatsBanner({ stats }: Props) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
      {ITEMS.map(({ key, label, Icon }) => (
        <div
          key={key}
          className="eth-card flex flex-col items-center gap-1 p-4 text-center"
        >
          <Icon
            size={22}
            className="text-primary"
            weight="duotone"
          />
          <span className="text-2xl font-bold text-text-primary font-brand">
            {stats ? formatNum(stats[key]) : "—"}
          </span>
          <span className="text-xs text-text-muted">
            {label}
          </span>
        </div>
      ))}
    </div>
  );
}
